import { Component, EventEmitter, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'app/fuse-template/core/auth/auth.service';
import { fancyTimeFormat } from 'app/helpers/fancyTimeFormat';
import { firstAndMiddleNameUser } from 'app/helpers/firstAndMiddleNameUser';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { FormService } from 'app/services/system/form/form.service';
import { environment } from 'environments/environment';
import { Subject, finalize, takeUntil, takeWhile, tap, timer } from 'rxjs';
import { DialogGeneral } from '../../DialogGeneral';

@Component({
    selector: 'dialog-audkenning-confirm-extend-token',
    templateUrl: 'dialog-audkenning-confirm-extend-token.html',
    styleUrls: ['dialog-audkenning-confirm-extend-token.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogAudkenningConfirmExtendToken extends DialogGeneral {
    extendTokenHttpReqLoading: boolean = true;
    hasLoaded: boolean = false;
    refreshTokenTimeWarning: number = environment.refreshTokenTimeWarning;
    rootPublicUrl: string = environment.rootPublicUrl;
    firstAndMiddleName: string = '';
    userConfirmed: boolean = false;

    lastTokenSeconds: number = 0;
    countdown: number = 60 * (environment.refreshTokenTime - environment.refreshTokenTimeWarning);
    countdownMapping: any = {
        '=1': '# s',
        other: '# s',
    };

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<DialogAudkenningConfirmExtendToken>,
        private lsrAuthService: LsrauthService,
        private authService: AuthService,
        private _router: Router,
        private formService: FormService,
        private dialog: MatDialog
    ) {
        super(matDialogRef);
        matDialogRef.disableClose = true;
        this.lsrAuthService.fetchUserDetails().subscribe((res) => {
            this.firstAndMiddleName = firstAndMiddleNameUser(res.user.nafn);
            this.hasLoaded = true;
        });
        this.countDown();
    }

    ngOnInit(): void {
        this.lastTokenSeconds = environment.refreshTokenTime * 60 - this.countdown;
    }

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    countDown() {
        // Redirect after the countdown
        timer(1000, 1000)
            .pipe(
                finalize(() => {}),
                takeWhile(() => this.countdown > 0),
                takeUntil(this._unsubscribeAll),
                tap(() => {
                    this.countdown--;
                    this.lastTokenSeconds = environment.refreshTokenTime * 60 - this.countdown;
                })
            )
            .subscribe();
    }

    closeSubscribe() {
        try {
            this._unsubscribeAll.next(null);
            this._unsubscribeAll.complete();
        } catch {}
    }

    fancyTimeFormat(s) {
        return fancyTimeFormat(s);
    }

    fancyMinute(s) {
        let _ret = Math.floor(s / 60);
        if (_ret == 0) {
            _ret = 1;
        }
        return _ret;
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this.closeSubscribe();
    }

    confirm() {
        this.userConfirmed = true;
        this.closeSubscribe();
        this.authService.updateToken().subscribe(() => {
            this.dialogRef.close();
        });
    }

    onConfirm = new EventEmitter();

    lokaClick() {
        this.formService.clearAllDirtyForms();
        this.authService.signOut();
        this._router.navigate(['innskra']);
        try {
            this.dialog.closeAll();
            this.close();
        } catch {}
    }
}
